import '../App.css'
import '../../src/footer.css'
const Footer = () => {
    return (
        <div className = "footer" style={{padding: '1.5rem'}}>
            Copyright © 2024 Akul Sareen.
        </div>
    )
}
export default Footer;